<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12">
                <v-card elevation="3" :loading="loading">
                    <v-card-text v-if="showWorkload == false">
                        <v-alert
                            text="No prepared workload as of now"
                            type="warning"
                        ></v-alert>
                    </v-card-text>
                    <v-card-text v-if="showWorkload == true">
                        <v-row>
                            <v-col v-if="workLoadData.approved_status == null" cols="12" md="11">
                                <v-alert
                                    v-if="!dbs_core_time || !dbs_consultation_time"
                                    text="Please update your code time and consulting time to ensure that the workload will be approved!"
                                    type="error"
                                    color="#E53935"
                                ></v-alert>
                                <v-alert
                                    v-else
                                    text="You have succesfully added your core time and consultation time. Thank you!"
                                    type="success"
                                ></v-alert>
                            </v-col>
                            <v-col v-if="workLoadData.approved_status == null" cols="12" md="1">
                                <v-btn @click="saveCoreAndConsultationTime()" color="darkGreen" class="d-flex">Save</v-btn>
                            </v-col>
                            <v-col v-if="workLoadData.prepared_status == null" cols="12">
                                <v-card elevation="3">
                                    <v-card-text>
                                        <v-chip color="darkGreen">For Preparation</v-chip>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col v-if="workLoadData.prepared_status != null" cols="12" md="3">
                                <v-card elevation="3">
                                    <v-card-text>
                                        <div class="font-weight-bold">Prepared By:</div>
                                        <div v-for="preparer in workLoadData.preparer" :key="preparer">
                                            <div class="mt-4">{{ getItemTitle(preparer) }}</div>
                                            <div class="text-caption font-weight-bold">{{ preparer?.designation }}</div>
                                        </div>
                                        <div class="mt-4 text-caption">{{ formatDate(workLoadData.prepared_date) }}</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col v-if="workLoadData.recommending_approval_status != null" cols="12" md="3">
                                <v-card elevation="3">
                                    <v-card-text>
                                        <div class="font-weight-bold">Recommending Approval By:</div>
                                        <div v-for="recommender in workLoadData.recommenders" :key="recommender">
                                            <div class="mt-4">{{ getItemTitle(recommender) }}</div>
                                            <div class="text-caption font-weight-bold">{{ recommender?.designation }}</div>
                                        </div>
                                        <div class="mt-4 text-caption">{{ formatDate(workLoadData.recommending_approval_date) }}</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col v-if="workLoadData.pre_approved_status != null" cols="12" md="3">
                                <v-card elevation="3">
                                    <v-card-text>
                                        <div class="font-weight-bold">Pre Approved By:</div>
                                        <div class="mt-4">{{ getItemTitle(workLoadData.pre_approver) }}</div>
                                        <div class="text-caption font-weight-bold">{{ workLoadData.pre_approver?.designation }}</div>
                                        <div class="mt-4 text-caption">{{ formatDate(workLoadData.pre_approved_date) }}</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col v-if="workLoadData.approved_status != null" cols="12" md="3">
                                <v-card elevation="3">
                                    <v-card-text>
                                        <div class="font-weight-bold">Approved By:</div>
                                        <div class="mt-4">{{ getItemTitle(workLoadData.approver) }}</div>
                                        <div class="text-caption font-weight-bold">{{ workLoadData.approver?.designation }}</div>
                                        <div class="mt-4 text-caption">{{ formatDate(workLoadData.approved_date) }}</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text v-if="showWorkload == true">
                        <v-row dense class="mt-lg-8">
                            <v-col cols="12" md="4">
                                <v-row align="center">
                                    <v-col cols="12" md="3" class="text-lg-right">
                                        <v-label color="black">Faculty:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <v-text-field
                                            v-model="faculty_name"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-row align="center">
                                    <v-col cols="12" md="5" class="text-lg-right">
                                        <v-label>Employment Status:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="7">
                                        <v-text-field
                                            v-model="employment_status"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-row align="center">
                                    <v-col cols="12" md="3" class="text-lg-right">
                                        <v-label>Designation:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <v-text-field
                                            v-model="designation"
                                            :rules="[formRules.required]"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-row align="center">
                                    <v-col cols="12" md="3" class="text-lg-right">
                                        <v-label>Rank:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <v-text-field
                                            v-model="rank"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-row align="center">
                                    <v-col cols="12" md="3" class="text-lg-right">
                                        <v-label>Institute:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <v-text-field
                                            v-model="institute"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-row align="center">
                                    <v-col cols="12" md="3" class="text-lg-right">
                                        <v-label>Department:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <v-text-field
                                            v-model="department"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-lg-8">
                            <v-col cols="12" md="6">
                                <v-row dense align="center">
                                    <v-col cols="12" class="text-lg-left ml-lg-12">
                                        <v-label>Educational Preparation:</v-label>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row align="center">
                                            <v-col cols="12" md="3" class="text-lg-right">
                                                <v-label>Bachelor's Degree:</v-label>
                                            </v-col>
                                            <v-col cols="12" md="9">
                                                <v-text-field
                                                    v-model="undergraduate"
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    readonly
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col v-if="graduate" cols="12">
                                        <v-row align="center">
                                            <v-col cols="12" md="3" class="text-lg-right">
                                                <v-label>Master's Degree:</v-label>
                                            </v-col>
                                            <v-col cols="12" md="9">
                                                <v-text-field
                                                    v-model="graduate"
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    readonly
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col v-if="post_graduate" cols="12">
                                        <v-row align="center">
                                            <v-col cols="12" md="5" class="text-lg-right">
                                                <v-label>Doctoral/Professional Degree:</v-label>
                                            </v-col>
                                            <v-col cols="12" md="7">
                                                <v-text-field
                                                    v-model="post_graduate"
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                    readonly
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row v-if="team_teach_name != null" dense class="mt-lg-8">
                            <v-col cols="12" md="6">
                                <v-row dense align="center">
                                    <v-col cols="12">
                                        <v-row align="center">
                                            <v-col cols="12" md="3" class="text-lg-right">
                                                <v-label>Team Teaching:</v-label>
                                            </v-col>
                                            <v-col cols="12" md="9">
                                                <v-text-field
                                                    v-model="team_teach_name"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row align="center">
                                            <v-col cols="12" md="4" class="text-lg-right">
                                                <v-label>Bachelor's Degree:</v-label>
                                            </v-col>
                                            <v-col cols="12" md="8">
                                                <v-text-field
                                                    v-model="team_teach_undergraduate"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row align="center">
                                            <v-col cols="12" md="4" class="text-lg-right">
                                                <v-label>Master's Degree:</v-label>
                                            </v-col>
                                            <v-col cols="12" md="8">
                                                <v-text-field
                                                    v-model="team_teach_graduate"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col v-if="team_teach_post_graduate" cols="12">
                                        <v-row align="center">
                                            <v-col cols="12" md="4" class="text-lg-right">
                                                <v-label>Doctoral/Professional Degree:</v-label>
                                            </v-col>
                                            <v-col cols="12" md="8">
                                                <v-text-field
                                                    v-model="team_teach_post_graduate"
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-8">
                            <v-col cols="12" md="6">
                                <v-row align="center">
                                    <v-col cols="12" md="3" class="text-lg-right">
                                        <v-label>Core Time:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="7">
                                        <v-text-field
                                            v-model="core_time"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-row align="center">
                                    <v-col cols="12" md="3" class="text-lg-right">
                                        <v-label>Consultation Time:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="7">
                                        <v-text-field
                                            v-model="consultation_time"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-card class="dt-container">    
                                    <v-data-table
                                        :mobile="isMobileOrTablet()"
                                        :headers="headers"
                                        :items="courseLoadData"
                                        :loading="loading"
                                        hide-default-footer
                                        class="text-caption"
                                    >
                                    <template v-slot:loading>
                                        <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                    </template>
                                    <template v-slot:item.title="{ item }">
                                        <div class="text-truncate" style="max-width: 70px;">
                                            {{ item.title }}
                                        </div>
                                    </template>
                                    <template v-slot:item.datecreated="{ item }">
                                        <span>{{ formatDateTime(item.datecreated)}} </span>
                                    </template>
                                    <template v-slot:[`item.action`]="{ item }">
                                        <div class="d-flex flex-column justify-end ga-2 py-2">
                                            <v-btn @click="showFacultyLoadDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                        </div>
                                    </template>
                                    </v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-8">
                            <v-col cols="12" md="6">
                                <v-row align="center">
                                    <v-col cols="12" md="4" class="text-lg-right">
                                        <v-label>Total Teaching Hours/Wk:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            v-model="total_teaching_hours"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-row align="center">
                                    <v-col cols="12" md="4" class="text-lg-right">
                                        <v-label>Total No. of Preparation:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            v-model="total_preparation"
                                            :rules="[formRules.required]"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row v-if="ms_load_eqv != 0" dense>
                            <v-col cols="12" md="6">
                                <v-row align="center">
                                    <v-col cols="12" md="4" class="text-lg-right">
                                        <v-label>Total MS Load Equivalent :</v-label>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            v-model="ms_load_eqv"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-row align="center">
                                    <v-col cols="12" md="4" class="text-lg-right">
                                        <v-label>Total  No. of MS Student:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            v-model="ms_total_student"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row v-if="ge_load_eqv != 0" dense>
                            <v-col cols="12" md="6">
                                <v-row align="center">
                                    <v-col cols="12" md="4" class="text-lg-right">
                                        <v-label>Total GE Load Equivalent:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            v-model="ge_load_eqv"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-row align="center">
                                    <v-col cols="12" md="4" class="text-lg-right">
                                        <v-label>Total  No. of GE Student:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            v-model="ge_total_student"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row v-if="profed_load_eqv != 0" dense>
                            <v-col cols="12" md="6">
                                <v-row align="center">
                                    <v-col cols="12" md="4" class="text-lg-right">
                                        <v-label>Total ProfEd Load Equivalent :</v-label>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            v-model="profed_load_eqv"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-row align="center">
                                    <v-col cols="12" md="4" class="text-lg-right">
                                        <v-label>Total  No. of ProfEd Student:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            v-model="profed_total_student"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row v-if="gs_load_eqv != 0" dense>
                            <v-col cols="12" md="6">
                                <v-row align="center">
                                    <v-col cols="12" md="4" class="text-lg-right">
                                        <v-label>Total GS Load Equivalent :</v-label>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            v-model="gs_load_eqv"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-row align="center">
                                    <v-col cols="12" md="4" class="text-lg-right">
                                        <v-label>Total  No. of GS Student:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            v-model="gs_total_student"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-8">
                            <v-col cols="12">
                                <v-row dense align="center">
                                    <v-col cols="12" md="6">
                                        <span class="font-weight-bold text-h6">ADMIN Load Release</span>
                                    </v-col>
                                    <v-col cols="12" class="mt-1">
                                        <v-card class="dt-container">    
                                            <v-data-table
                                                :mobile="isMobileOrTablet()"
                                                :headers="loadHeaders"
                                                :items="adminLoadData"
                                                :loading="loading"
                                                hide-default-footer
                                                class="text-body-2"
                                            >
                                            <template v-slot:loading>
                                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                            </template>
                                            <template v-slot:item.description="{ item }">
                                                <div class="text-truncate" style="max-width: 800px;">
                                                    {{ item.description }}
                                                </div>
                                            </template>
                                            <template v-slot:item.datecreated="{ item }">
                                                <span>{{ formatDateTime(item.datecreated)}} </span>
                                            </template>
                                            <template v-slot:item.to_be_counted="{ item }">
                                                <v-icon v-if="item.to_be_counted == true" color="green">mdi-check</v-icon>
                                                <v-icon v-else color="red">mdi-close</v-icon>
                                            </template>
                                            <template v-slot:[`item.action`]="{ item }">
                                                <div class="d-flex justify-end ga-2">
                                                    <v-btn @click="showEditAdminLoadDialog(item)" size="x-small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                                    <v-btn  @click="showDeleteAdminDialog(item)" size="x-small" variant="outlined" text="Remove" color="red" elevation="3"></v-btn>
                                                </div>
                                            </template>
                                            </v-data-table>
                                        </v-card>
                                    </v-col>   
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-8">
                            <v-col cols="12">
                                <v-row dense align="center">
                                    <v-col cols="12" md="6">
                                        <span class="font-weight-bold text-h6">REP Load Release</span>
                                    </v-col>
                                    <v-col cols="12" class="mt-1">
                                        <v-card class="dt-container">    
                                            <v-data-table
                                                :mobile="isMobileOrTablet()"
                                                :headers="repHeaders"
                                                :items="repLoadData"
                                                :loading="loading"
                                                hide-default-footer
                                                class="text-body-2"
                                            >
                                            <template v-slot:loading>
                                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                            </template>
                                            <template v-slot:item.rep_title.title="{ item }">
                                                <div style="max-width: 800px;">
                                                    <span >
                                                        {{ item.rep_title.title }}
                                                    </span>

                                                    <span v-if="item.rep_title.category == 'Res'"> (Res)</span>
                                                    <span v-if="item.rep_title.category == 'Ext'"> (Ext)</span>
                                                    <span v-if="item.rep_title.category == 'Prod'"> (Prod)</span>

                                                    <span>({{ item.role  }})</span>
                                                </div>
                                            </template>
                                            <template v-slot:item.datecreated="{ item }">
                                                <span>{{ formatDateTime(item.datecreated)}} </span>
                                            </template>
                                            </v-data-table>
                                        </v-card>
                                    </v-col>   
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row dense class="mt-8">
                            <v-col cols="12">
                                <v-row align="center">
                                    <v-col cols="12" md="8" xl="7" class="text-lg-right">
                                        <v-label>TOTAL IREPA (Instruction, Research, Extension, Production and Administrative) LOAD UNITS/WK:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field
                                            v-model="total_irepa_units"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12">
                                <v-row align="center">
                                    <v-col cols="12" md="8" xl="7" class="text-lg-right">
                                        <v-label>TOTAL IREPA (Instruction, Research, Extension, Production and Administrative) LOAD HOURS/WK:</v-label>
                                    </v-col>
                                    <v-col cols="12" md="2">
                                        <v-text-field
                                            v-model="total_irepa_hours"
                                            color="darkGreen"
                                            variant="underlined"
                                            density="comfortable"
                                            class="font-weight-bold"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
    data () {
        return {
            loading: false,

            id: null,
            user_id: null,
            faculty_name: null,
            employment_status: null,
            designation: null,
            rank: null,
            institute: null,
            department: null,
            undergraduate: null,
            graduate: null,
            post_graduate: null,
            team_teach_name: null,
            team_teach_undergraduate: null,
            team_teach_graduate: null,
            team_teach_post_graduate: null,
            core_time: null,
            consultation_time: null,
            total_teaching_hours: null,
            total_preparation: null,
            ms_load_eqv: null,
            ms_total_student: null,
            ge_load_eqv: null,
            ge_total_student: null,
            profed_load_eqv: null,
            profed_total_student: null,
            gs_load_eqv: null,
            gs_total_student: null,
            total_irepa_units: null,
            total_irepa_hours: null,

            dbs_core_time: null,
            dbs_consultation_time: null,

            showWorkload: false,
            courseLoadData: [],
            adminLoadData: [],
            repLoadData: [],
            workLoadData: [],
            officeName: 'Office of the Vice President for Academic Affairs',

            headers: [
                { title: 'Course No.', align: 'start', sortable: true, key: 'code' },
                { title: 'Course Title', align: 'start', sortable: true, key: 'title' },
                { title: 'Unit', align: 'start', sortable: true, key: 'unit' },
                { title: 'Time', align: 'start', sortable: true, key: 'time' },
                { title: 'Day', align: 'start', sortable: true, key: 'day' },
                { title: 'Room', align: 'start', sortable: true, key: 'room' },
                { title: 'Program/Section', align: 'start', sortable: true, key: 'section_code' },
                { title: 'Class Size', align: 'start', sortable: true, key: 'class_size' },
                { title: 'Hours Lec (a)', align: 'start', sortable: true, key: 'hours_lecture' },
                { title: 'Hours Lab', align: 'start', sortable: true, key: 'hours_lab' },
                { title: 'Actual Contact Teaching Hrs/Wk', align: 'start', sortable: true, key: 'actual_contact_teaching' },
                { title: '.75 Eqv (b)', align: 'start', sortable: true, key: 'eqv' },
                { title: 'Total Load Eqv', align: 'end', sortable: true, key: 'total_eqv' },
                // { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            loadHeaders: [
                { title: 'Description', align: 'start', sortable: true, key: 'description' },
                { title: 'Hours', align: 'start', sortable: true, key: 'hours' },
                { title: 'Unit', align: 'start', sortable: true, key: 'unit' },
                { title: 'To Be Counted', align: 'end', sortable: true, key: 'to_be_counted' },
                // { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            repHeaders: [
                { title: 'Description', align: 'start', sortable: true, key: 'rep_title.title' },
                { title: 'Hours', align: 'start', sortable: true, key: 'unit_loading' },
                { title: 'Unit', align: 'end', sortable: true, key: 'unit_loading' },
            ],
        }
    },
    methods: {
        init(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-workload/findAllLoadByUserAndSemesterSchoolyear/' + this.$store.state.user.id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    if(res.data.length === 0){
                        this.showWorkload = false
                        this.loading = false
                    }
                    else{
                        this.showWorkload = true
                        this.workLoadData = res.data[0]
                        this.initUser(res.data[0])
                    }
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async initUser(data){
            this.id = data.id
            this.user = data.user
            this.user_id = data.user_id
            this.faculty_name = data.faculty_name
            this.employment_status = data.employment_status
            this.designation = data.designation
            this.rank = data.rank
            this.institute = data.institute
            this.department = data.department
            this.undergraduate = data.undergraduate
            this.graduate = data.graduate
            this.post_graduate = data.post_graduate
            this.team_teach_name = data.team_teach_name
            this.team_teach_undergraduate = data.team_teach_undergraduate,
            this.team_teach_graduate = data.team_teach_graduate,
            this.team_teach_post_graduate = data.team_teach_post_graduate,
            this.core_time = data.core_time
            this.consultation_time = data.consultation_time
            this.dbs_core_time = data.core_time
            this.dbs_consultation_time = data.consultation_time

            this.vpaa_staff_code = data.vpaa_staff_code

            await this.loadCourseLoad()

            this.total_teaching_hours = data.total_teaching_hours
            this.total_preparation = data.total_preparation
            this.ms_load_eqv = data.ms_load_eqv
            this.ms_total_student = data.ms_total_student
            this.ge_load_eqv = data.ge_load_eqv
            this.ge_total_student = data.ge_total_student
            this.profed_load_eqv = data.profed_load_eqv
            this.profed_total_student = data.profed_total_student
            this.gs_load_eqv = data.gs_load_eqv
            this.gs_total_student = data.gs_total_student

            await this.loadReleaseLoad()

            this.total_irepa_units = data.total_irepa_units
            this.total_irepa_hours = data.total_irepa_hours

            this.loading = false
        },
        async loadCourseLoad(){
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-load/findAllBySemesterAndSchoolyear/' + this.$store.state.user.id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.courseLoadData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async loadReleaseLoad(){
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/admin-load/findAllLoadByUserAndSemester/' + this.$store.state.user.id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.adminLoadData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/rep-unit-load/findAllLoadByUserAndSemester/' + this.$store.state.user.id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.repLoadData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        saveCoreAndConsultationTime(){
            const { showSnackbar } = useSnackbar()
            let formData = {
                id: this.id,
                core_time: this.core_time,
                consultation_time: this.consultation_time
            }

            const token = localStorage.getItem('aums-token')
            axios.post(process.env.VUE_APP_SERVER_URL + '/faculty-workload/updateCoreandConsultationTime', formData,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 200){
                    showSnackbar('Core and Consultation Time successfully updated!')
                    this.init()
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            })
        },
        getItemTitle(item) {
            return `${item?.fname ?? ''} ${item?.mname ? item?.mname[0] + '.' : ''} ${item?.lname ?? ''}${item?.suffix ? ' ' + item?.suffix : ''}${item?.post_nominal ? ', ' + item?.post_nominal : ''}`;
        },
        getRepCategory(category){
            if(category == 'Res'){
                return '(Res)'
            }
            else if(category == 'Ext'){
                return '(Ext)'
            }
            else if(category == 'Pro'){
                return '(Prod)'
            }
        },
        getRepRole(role){
            if(role == 'Member'){
                return '(Member)'
            }
            else if(role == 'Leader'){
                return '(Leader)'
            }
        },
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>